// extracted by mini-css-extract-plugin
export var body = "styles-module--body--cd008";
export var header = "styles-module--header--4c9b0";
export var input = "styles-module--input--1bdc2";
export var label = "styles-module--label--ff6ee";
export var selected = "styles-module--selected--5e803";
export var sliderContainer = "styles-module--sliderContainer--b9b6f";
export var submit = "styles-module--submit--01dfa";
export var toggles = "styles-module--toggles--32ce4";